import { path, propEq, find, useWith, identity, pathOr } from 'ramda'
import { globalizeSelectors } from 'zeal-redux-utils'

const localState = state => {
  const question = path(['app', 'debate', 'question'])(state)
  const questions = path(['questions'])(question)
  const selectedQuestion = pathOr(0, ['selectedQuestion'], question)

  return path(['arguments'])(path([selectedQuestion])(questions))
}

const sample = path([0])
const selected = useWith(find, [propEq('id'), identity])

export default globalizeSelectors(localState, {
  sample,
  selected
})



// WEBPACK FOOTER //
// ./client/modules/debate/selectors/argument.js